import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import Message from 'components/Message';
import { bem } from 'helpers/class-name';
import { buildClassLevelSpotsDropdownOptions } from './SmartTools.helpers';
import { messages } from './ClassLevelMinimumSpotsFlyout.messages';

const { element } = bem('class-level-minimum-spots-flyout');

const ClassTableContent = ({ control, venueClasses, renderSpotsDropdown }) => {
  const intl = useIntl();

  const dropdownOptions = buildClassLevelSpotsDropdownOptions(intl);

  return (
    <div className={element('table-wrapper')}>
      <div className={element('mobile-header')}>
        <Message message={messages.className} />
      </div>
      <table className={element('table')}>
        <thead>
          <tr>
            <th className={element('table-header', 'class-name')}>
              <Message message={messages.className} />
            </th>
            <th className={element('table-header', 'peak')}>
              <Message message={messages.peak} />
            </th>
            <th className={element('table-header', 'off-peak')}>
              <Message message={messages.offPeak} />
            </th>
          </tr>
        </thead>
        <tbody>
          {venueClasses.map(classItem => {
            const { classId, className } = classItem;
            const peakDropdown = renderSpotsDropdown(
              control,
              `classes.${classId}.minimumSpotsPeakTime`,
              dropdownOptions
            );
            const offPeakDropdown = renderSpotsDropdown(
              control,
              `classes.${classId}.minimumSpotsOffpeakTime`,
              dropdownOptions
            );

            return (
              <tr key={classId} className={element('table-row')}>
                <td className={element('table-cell', { 'class-name': true })}>{className}</td>
                <td className={element('table-cell', { peak: true })}>
                  <div className={element('mobile-cell-header')}>
                    <Message message={messages.peak} />
                  </div>
                  {peakDropdown}
                </td>
                <td className={element('table-cell', { 'off-peak': true })}>
                  <div className={element('mobile-cell-header')}>
                    <Message message={messages.offPeak} />
                  </div>
                  {offPeakDropdown}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

ClassTableContent.propTypes = {
  control: PropTypes.shape({}).isRequired,
  venueClasses: PropTypes.arrayOf(
    PropTypes.shape({
      classId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      className: PropTypes.string.isRequired,
    })
  ).isRequired,
  renderSpotsDropdown: PropTypes.func.isRequired,
};

export default ClassTableContent;
